<template>
  <div class="grupo-familiar" v-loading="loading">
    <el-row
      v-for="(contrato, index) in listaContratoBeneficia"
      :key="index"
    >
      <div>
        <div class="contrato">
          <h1>{{ contrato.plano }}</h1>
          <span class="numero-contrato">{{ textoVinculoContrato }}: {{ contrato.contrato }}</span>
        </div>
        <div class="beneficiarios">
          <div v-if="contrato.data.length">
            <el-button
              v-for="(beneficiario, indexB) in contrato.data"
              :key="indexB"
              :style="estiloBotao"
              @click="select(beneficiario)"
            >
              <div class="container">
                <div class="col1">
                  <div class="nome">
                    {{ beneficiario.nome }}
                  </div>
                  <div class="row">
                    <div class="texto">
                      {{ beneficiario.matricula }}
                    </div>
                    <div class="tipoBeneficiario">
                      {{ beneficiario.tipoBeneficiario }}
                    </div>
                  </div>
                </div>
                <div class="col2">
                  <div class="row">
                    <div
                      class="circle"
                      :style="{background: beneficiario.cor}"
                    >
                      <div class="abreviatura">
                        {{ beneficiario.abreviacao }}
                      </div>
                    </div>
                    <i
                      style="margin-left: 15px"
                      :style="estiloIcone"
                      class="el-icon-arrow-right"
                    />
                  </div>
                </div>
              </div>
            </el-button>
          </div>
          <div
            v-else
            style="background: #F6F6F6; padding: 15px; text-align: center; border-radius: 5px;  color: #909399;"
          >
            Não há beneficiários com acesso aos dados
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { mapListaByContrato } from '@/components/GrupoFamiliar/GrupoFamiliarHelpers'

export default {
  name: 'GrupoFamiliarBeneficiario',
  props: {
    idFuncionalidade: {
      type: [Number, String]
    },
    value: {
      type: Object,
      default: () => ({})
    },
    numeroContrato: {
      type: String
    }
  },
  watch: {
    value (newValue) {
      this.beneficiarioSelecionado = newValue
    }
  },
  data () {
    return {
      listaContratoBeneficia: [],
      beneficiarioSelecionado: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo', 'aplicacao', 'textoVinculoContrato']),
    ...mapGetters('Login', ['contratos', 'beneficiarios']),
    ...mapState('SetupApp', ['apiGrupoFamiliar']),
    estiloBotao () {
      if (!this.estilo.aplicacao) { return '' }
      return {
        'background': `${this.estilo.aplicacao.corPrimariaAplicacao}0d`
      }
    },
    estiloIcone () {
      if (!this.estilo.aplicacao) { return '' }
      return {
        'color': `${this.estilo.aplicacao.corPrimariaAplicacao}`
      }
    },
    visualizaContratosVazios () {
      if (!this.aplicacao.grupoFamiliar) {
        return true
      }

      return this.aplicacao.grupoFamiliar.visualizaContratosVazios
    }
  },
  methods: {
    async init () {
      // Sempre que iniciado o Grupo Familiar deve iniciar com nenhum deles selecionados
      this.beneficiarioSelecionado = null

      let beneficiariosIntegracao = null
      try {
        beneficiariosIntegracao = await this.getGrupoFamiliar()
      } catch (ignored) {}
      this.loading = false

      this.listaContratoBeneficia = mapListaByContrato(
        beneficiariosIntegracao,
        this.contratos,
        this.beneficiarios,
        this.idFuncionalidade,
        this.visualizaContratosVazios
      )

      this.$emit('contratos', this.listaContratoBeneficia)

      if (this.numeroContrato) {
        const filtrado = this.listaContratoBeneficia.filter((el, i) => {
          return el.contrato === this.numeroContrato
        })
        this.listaContratoBeneficia = filtrado
      }
    },
    async getGrupoFamiliar () {
      if (this.apiGrupoFamiliar.grupoFamiliar) {
        const result = await this.apiGrupoFamiliar.grupoFamiliar({
          payload: {
            idFuncionalidade: this.idFuncionalidade
          },
          handlerErrorIgnore: true
        })

        if (!result.status) {
          return false
        }
        const { contratos } = result.data

        const invalid = contratos.filter(contrato => {
          return !contrato.beneficiarios
        })

        if (invalid.length) {
          return false
        }
        return contratos
      }
      return false
    },
    select (beneficiario) {
      // Propaga a mudança no valor
      this.$emit('input', beneficiario)
      this.$emit('click', beneficiario)
      this.beneficiarioSelecionado = beneficiario
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style>
.container {
  width: 100%;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
}

.col1 {
  width: 80%;
  align-items: flex-start;
}

.col2 {
  padding-left: 13px;
}

.row {
  margin-top: 2px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.circle {
  height: 35px;
  width: 35px;
  border-radius: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nome {
  text-transform: none;
  font: normal normal 600 14px/19px Open Sans;
  letter-spacing: 0;
  color: #333333;
}

.texto {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #555555;
}

.tipoBeneficiario {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #555555;
  margin-left: 5px;
  text-transform: capitalize;
}

.abreviatura {
  font-size: 17px;
  font-family: "Open Sans";
  color: #FFFFFF;
}
</style>
